'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'cassette-tape';
var width = 512;
var height = 512;
var aliases = [128429];
var unicode = 'f8ab';
var svgPathData = 'M0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-13.4 0-28.4-75.7c-8.2-21.9-29.1-36.3-52.4-36.3l-195.6 0c-23.3 0-44.2 14.5-52.4 36.3L77.4 448 64 448c-35.3 0-64-28.7-64-64L0 128zM361.3 389.2l22.1 58.8-254.7 0 22.1-58.8c1.2-3.1 4.2-5.2 7.5-5.2l195.6 0c3.3 0 6.3 2.1 7.5 5.2zM309.5 192l-106.9 0c3.5 10 5.5 20.8 5.5 32s-1.9 22-5.5 32l106.9 0c-3.5-10-5.5-20.8-5.5-32s1.9-22 5.5-32zm90.5 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM80 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCassetteTape = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;